import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loadng-transf',
  templateUrl: './loadng-transf.component.html',
  styleUrls: ['./loadng-transf.component.scss']
})
export class LoadngTransfComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
